import BillingPlanFeature from './BillingPlanFeature';

export default BillingPlanFeature;
